module.exports = __webpack_public_path__ + "img/Sofa_2.bdcd46f.png";